import type { FormattedMemberChangeLog } from '@library/types/members/memberChangeLogs';
import { getSplitDateTime } from '@library/component-utils/dateTime';

export interface MemberChangeLogRowProps {
  changeLog: FormattedMemberChangeLog;
}

export const MemberChangeLogRow = ({ changeLog }: MemberChangeLogRowProps) => {
  const { id, description, noteType, createdAt, adminUser } = changeLog;

  const createdDateTime = getSplitDateTime(
    createdAt,
    'MMM dd, yyyy',
    'h:mm:ss a'
  );

  const { email, fullName } = adminUser;

  return (
    <div
      aria-hidden="true"
      className="border-soFresh-140 text-soClean-110 relative flex items-center border-b text-xs"
      data-testid={`member-change-log-${id}`}
    >
      <p className="flex basis-28 p-3" data-testid="member-change-log-id">
        {id}
      </p>
      <p
        className="flex basis-80 break-words p-3 capitalize"
        data-testid="member-change-log-description"
      >
        {description}
      </p>
      <p
        className="flex basis-40 p-3 capitalize"
        data-testid="member-change-log-noteType"
      >
        {noteType}
      </p>
      <p
        className="flex basis-40 flex-col p-3"
        data-testid="member-change-log-timestamp"
      >
        <span className="leading-5">{createdDateTime.date}</span>
        <span className="text-soClean-160">{createdDateTime.time}</span>
      </p>
      <p
        className="flex basis-72 flex-col p-3"
        data-testid="member-change-log-adminUser"
      >
        <span className="font-heebo text-soClean-100 block text-sm font-medium capitalize tracking-tight">
          {fullName}
        </span>
        <span className="text-soClean-170 font-heebo block text-xs font-medium tracking-tight">
          {email}
        </span>
      </p>
    </div>
  );
};
